import {
  Avatar,
  Box,
  Flex,
  Heading,
  HStack,
  VStack,
  Stack,
  Text,
  LinkBox,
  LinkOverlay,
} from "@chakra-ui/react";
import { Link as RemixLink } from "@remix-run/react";
import { ImagePlaceholder } from "./ImagePlaceholder.jsx";
import { Paper } from "#app/components/Paper.jsx";
import { formatLongDate } from "#app/utils/dateFormat.js";
import { useLocale } from "#app/context/LocaleContext.jsx";

export const BlogPostCard = ({ post }) => {
  const locale = useLocale();
  const { slug, title, excerpt, publishedAt, readTime, author, featuredImage } =
    post;

  return (
    <Paper
      as={LinkBox}
      _hover={{ transform: "translateY(-2px)", shadow: "lg" }}
      transition="all 0.2s"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        gap="6"
        align={{ md: "center" }}
      >
        <Box flex="1" position="relative" sx={{ aspectRatio: "16/9" }} minH="0">
          {featuredImage ? (
            <Box
              as="img"
              src={featuredImage}
              alt={title}
              position="absolute"
              inset="0"
              w="full"
              h="full"
              objectFit="cover"
              rounded="lg"
            />
          ) : (
            <ImagePlaceholder position="absolute" inset="0" rounded="lg" />
          )}
        </Box>
        <Stack flex="1.5" gap="3">
          <HStack color="muted" fontSize="sm">
            <Text>{formatLongDate(publishedAt, locale)}</Text>
            <Text>•</Text>
            <Text>{readTime} min read</Text>
          </HStack>
          <Heading size="sm" lineHeight="1.2">
            <LinkOverlay as={RemixLink} to={`/blog/${slug}`}>
              {title}
            </LinkOverlay>
          </Heading>
          <Text lineHeight="1.6">{excerpt}</Text>
          {author && (
            <HStack spacing={3} minW="0" flex="1">
              <Avatar size="sm" name={author.name} src={author.avatar} />
              <VStack align="start" spacing={0} minW="0">
                <Text fontWeight="medium" fontSize="sm">
                  {author.name}
                </Text>
                <Text fontSize="xs" color="muted" noOfLines={1}>
                  {author.title}
                </Text>
              </VStack>
            </HStack>
          )}
        </Stack>
      </Flex>
    </Paper>
  );
};
